<template>
  <div
    class="w-full flex font-normal p-2 border-t border-gray-400"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div class="w-1/3 text-left">
      {{ member.fullName }}
      <span
        v-show="isHovered"
        :class="{ 'text-blue-500': member.status === 'active', 'text-gray-500': member.status === 'pending' }"
      >
        {{ member.status }}
      </span>
    </div>
    <div class="w-1/3 text-right text-gray-500">
      {{ member.email }}
    </div>
    <div class="w-1/3 text-right">
      <span
        v-if="!isHovered || (isHovered && member.isEmailVerified)"
        class="text-gray-500"
      >
        {{ member.lastLogin | format }}
      </span>
      <span
        v-else-if="isHovered && !member.isEmailVerified"
        class="text-blue-500 underline cursor-pointer"
        @click="resendInvitation()"
      >
        {{ $t("Resend invite email", "Resend invite email") }}
      </span>
    </div>
  </div>
</template>

<script>
import { actionNames } from '@/settings/store'
import moment from 'moment'

export default {
  name: 'Member',
  filters: {
    format: function (date) {
      return moment(date).fromNow()
    }
  },
  props: {
    member: { type: Object, default: () => {} }
  },
  data () {
    return {
      isHovered: false
    }
  },
  methods: {
    async resendInvitation () {
      try {
        await this.$store.dispatch(actionNames.RESEND_INVITATION, this.member.id)
        this.$toast.success('Invitation successfully sent!')
      } catch (e) {
        this.$toast.error('Something went wrong! Please try again later or contact your account manager.')
      }
    }
  }
}
</script>
